import { IUiProductsSearchModel } from '@clubhub/ignite/models/products';
import {
  BtlType, HolidayLetFrequency, MortgageType, ProductType, PurchaserType, RepaymentMethod,
  RepaymentVehicle,
} from '@shared/models';

export const mockProductSearchRequest: IUiProductsSearchModel = {
  mortgageRequirements: {
    mortgageType: MortgageType.Purchase,
    productTypeExtended: ProductType.Standard,
    remortgageType: undefined,
    purchaserType: PurchaserType.FirstTimeBuyer,
    propertyValue: 100000,
    loanAmount: 50000,
    helpToBuy: false,
    mortgageLender: {
      value: 'LenderX',
      label: 'LenderX',
    },
    productTransferInitialDate: {
      day: 11,
      month: 12,
      year: 2022,
    },
    repaymentMethod: {
      value: RepaymentMethod.CapitalAndInterest,
      showInterestOnlyCriteria: false,
      showInterestOnlyPartAndPartCriteria: false,
    },
    repaymentVehicle: RepaymentVehicle.SaleOfProperty,
    equityValue: 50_000,
    mortgageTerm: {
      years: 20,
      months: 0,
    },
    btlType: BtlType.Standard,
    limitedCompanyPurchase: false,
    portfolioLandlord: false,
    holidayLetIncome: {
      holidayLetIncomeLow: 33,
      holidayLetIncomeMedium: 44,
      holidayLetIncomeHigh: 55,
      holidayLetIncomeFrequency: HolidayLetFrequency.Monthly,
    },
  },
  productsSearchId: '',
  bridging: {
    regulated: true,
  },
};
